import ApiService from '@/core/services/api.service';

const getAllStore = (success, fail) => {
  ApiService.get('/stores/getStores')
    .then((response) => success(response))
    .catch((response) => fail(response));
};

export { getAllStore };
